import { UpdateProcessMapPositionsRequestSchema, UpdateProcessMapPositionsResponseSchema, ResetProcessMapPositionsResponseSchema } from './update-process-map-positions.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
export const updateProcessMapPositionsContract = {
    method: 'PUT',
    path: '/api/v2/process/map/positions',
    description: 'Bulk upsert process map node positions',
    requestSchema: UpdateProcessMapPositionsRequestSchema,
    responseSchema: UpdateProcessMapPositionsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body',
            401: 'Unauthorized'
        }
    }
};
export const resetProcessMapPositionsContract = {
    method: 'DELETE',
    path: '/api/v2/process/map/positions',
    description: 'Reset all process map node positions to auto-layout',
    responseSchema: ResetProcessMapPositionsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized'
        }
    }
};

//# sourceMappingURL=update-process-map-positions.contract.js.map